import React from "react";
import {Route, Routes} from "react-router-dom";
import DocumentList from "../container/document/DocumentList";
import CreateDocument from "../container/document/CreateDocument";
import UpdateDocument from "../container/document/UpdateDocument";
import UpdateRevisionDocument from "../container/document/UpdateRevisionDocument";
import CreateRevisionDocument from "../container/document/CreateRevisionDocument";
import RevisionDocumentList from "../container/document/RevisionDocumentList";

const Document = () => {
  return (
    <Routes>
      <Route path="List/:id" element={<DocumentList />} />
      <Route path="CreateDocument" element={<CreateDocument />} />
      <Route path="EditDocument/:id" element={<UpdateDocument />} />
      <Route path="ListRevision/:id" element={<RevisionDocumentList />} />
      <Route path="CreateRevision" element={<CreateRevisionDocument />} />
      <Route path="EditRevision/:id" element={<UpdateRevisionDocument />} />
    </Routes>
  );
};

export default Document;
